import { useClientLayoutEffect } from '@fabric-app/hooks/useClientLayoutEffect';
import { keyToDisplayValue } from '../modifierKeys.js';
import { useMemo } from 'react';
import { create } from 'zustand';
import { delayedTrackZustand } from '@fabric-app/compat/capabilities/openreplay';

const useKeyboardMapStore = create(delayedTrackZustand((set) => ({
  codeToKeyMap: /* @__PURE__ */ new Map(),
  keyToCodeMap: /* @__PURE__ */ new Map(),
  isLoaded: false,
  isError: false,
  setKeyboardMap: (keyboardMap) => {
    const keyToCodeMap = /* @__PURE__ */ new Map();
    Array.from(keyboardMap).forEach(([code, key]) => {
      keyToCodeMap.set(key.toLowerCase(), code);
    });
    set({
      codeToKeyMap: keyboardMap,
      keyToCodeMap,
      isLoaded: true
    });
  },
  setLoadError: () => {
    set({
      isError: true,
      isLoaded: false
    });
  }
})));
const useKeyboardMapChangeListener = () => {
  const { setKeyboardMap, setLoadError } = useKeyboardMapStore((state) => ({
    setKeyboardMap: state.setKeyboardMap,
    setLoadError: state.setLoadError
  }));
  useClientLayoutEffect(() => {
    if (typeof navigator !== "undefined" && "keyboard" in navigator) {
      try {
        navigator.keyboard.getLayoutMap().then((keyboardLayoutMap) => {
          setKeyboardMap(keyboardLayoutMap);
        });
      } catch {
        setLoadError();
      }
    } else {
      setLoadError();
    }
  }, []);
};
const codeOrderValue = {
  Option: 7,
  Alt: 7,
  Control: 5,
  Meta: 10,
  Shift: 4
};
const getOrderValue = (code) => {
  return codeOrderValue[code] || 0;
};
const sortRecordedHotkeys = (data) => {
  return data.sort((a, b) => {
    return getOrderValue(b) - getOrderValue(a);
  });
};
const useRecordedHotkeysToActualLayoutMapper = () => {
  const keyboardMap = useKeyboardMapStore((state) => ({
    keyToCode: state.keyToCodeMap,
    codeToKey: state.codeToKeyMap
  }));
  const handler = useMemo(() => !keyboardMap ? void 0 : (recordedHotkeys) => {
    const map = keyboardMap.codeToKey;
    const keys = sortRecordedHotkeys(recordedHotkeys.map((item) => {
      const value = item.value;
      return map.get(value) || value;
    }));
    const keysDisplayed = keys.map(keyToDisplayValue);
    const keysDisplayedStr = keysDisplayed.join(" + ");
    return {
      isMapped: true,
      keys,
      keysDisplayed,
      keysDisplayedStr
    };
  }, [
    keyboardMap
  ]);
  return handler;
};

export { useKeyboardMapChangeListener, useKeyboardMapStore, useRecordedHotkeysToActualLayoutMapper };
//# sourceMappingURL=useKeyboardMap.js.map
